<template>
  <div>
    <div class="back_slide_wrap" v-if="this.$route.path == '/main'">
      <carousel
        id="main_visual_slide"
        :items="1"
        :loop="false"
        :nav="false"
        :autoplay="true"
        class="owl-loaded"
        :autoplayTimeout="10000"
        :autoHeight="true"
      >
        <div class="item">
          <div class="main_visual_img01">
            <div class="container">
              <div class="m_v_slide_inner">
                <!-- <div class="header_gsis">
                  <strong>GSIS</strong>
                  <span>Global Service Information System</span>
                </div> -->
                <p class="m_slogan_text">Value beyond information, GSIS<em>Global Service Information System</em></p>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="item">
          <div class="main_visual_img02">
            <div class="container">
              <div class="m_v_slide_inner">
                <div class="header_gsis">
                  <strong>GSIS</strong>
                  <span>Global Service Information System</span>
                </div>
                <p class="m_slogan_text">
                  Search your technical<em>contents everywhere</em>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="item">
          <div class="main_visual_img03">
            <div class="container">
              <div class="m_v_slide_inner">
                <div class="header_gsis">
                  <strong>GSIS</strong>
                  <span>Global Service Information System</span>
                </div>
                <p class="m_slogan_text">
                  Agile update, More information,<em>Where you want it</em>
                </p>
              </div>
            </div>
          </div>
        </div> -->
      </carousel>
    </div>
    <header ref="header" :class="{ main_header: this.$route.path == '/main?noCache='+date }">
      <div class="header_wrap">
        <div class="header_inner container">
          <h1>
            <router-link to="/main" @click.native="$store.commit('setActive', '')"
              >HD HYUNDAI INFRACORE GSIS</router-link
            >
          </h1>
          <!--헤더 우측-->
          <div class="header_util_inner">
            <div class="header_util_box">
              <div
                v-if="this.$session.get('userName') != null &&
                  this.$session.get('userName') != '' && 
                  this.$session.get('userName') != undefined "
                class="header_user dropdown"
              >
                <span
                  type="button"
                  id="dropdownMenuButton1"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  class="header_user_name"
                  >{{ this.$session.get("userName") }}</span
                >
                <ul
                  v-if="this.$session.get('userName') != 'dxp'"
                  aria-labelledby="dropdownMenuButton1"
                  class="dropdown-menu"
                  style="margin: 0px"
                >
                  <li>
                    <a
                      href="javascript:void(0)"
                      @click="
                        [
                          classActive('My Library'),
                          saveComponentName('Bookmarks'),
                          goMyLibrary(),
                        ]
                      "
                      class="dropdown-item-mygsis"
                      >{{ $t("common.myLibrary") }}</a
                    >
                  </li>
                  <li>
                    <a href="#" @click="goLogout" class="dropdown-item-logoutbtn">{{
                      $t("common.logout")
                    }}</a>
                  </li>
                </ul>
              </div>
              <div v-else class="header_user">
                <router-link :to="'/login'" @click.native="reset" class="header_user_name"
                  >LogIn</router-link
                >
              </div>
              <div class="top_language_box dropdown">
                <button
                  type="button"
                  id="dropdownMenuButton1"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  class="t_l_text"
                >
                  {{ localeName }}
                </button>
                <ul
                  aria-labelledby="dropdownMenuButton1"
                  class="dropdown-menu"
                  style="margin: 0px"
                >
                  <li>
                    <a
                      href="#"
                      @click="[changeLocale('English'), ($i18n.locale = 'English')]"
                      class="dropdown-item"
                      >English</a
                    >
                  </li>
                  <li>
                    <a
                      href="#"
                      @click="[changeLocale('Korean'), ($i18n.locale = 'Korean')]"
                      class="dropdown-item"
                      >Korean</a
                    >
                  </li>
                  <li>
                    <a
                      href="#"
                      @click="
                        [
                          changeLocale('Brazilian Portuguese'),
                          ($i18n.locale = 'Brazilian Portuguese'),
                        ]
                      "
                      class="dropdown-item"
                      >Brazilian Portuguese</a
                    >
                  </li>
                  <li>
                    <a
                      href="#"
                      @click="[changeLocale('Burmese'), ($i18n.locale = 'Burmese')]"
                      class="dropdown-item"
                      >Burmese</a
                    >
                  </li>
                  <li>
                    <a
                      href="#"
                      @click="[changeLocale('Chinese'), ($i18n.locale = 'Chinese')]"
                      class="dropdown-item"
                      >Chinese</a
                    >
                  </li>
                  <li>
                    <a
                      href="#"
                      @click="[changeLocale('French'), ($i18n.locale = 'French')]"
                      class="dropdown-item"
                      >French</a
                    >
                  </li>
                  <li>
                    <a
                      href="#"
                      @click="[changeLocale('Indonesian'), ($i18n.locale = 'Indonesian')]"
                      class="dropdown-item"
                      >Indonesian</a
                    >
                  </li>
                  <li>
                    <a
                      href="#"
                      @click="
                        [changeLocale('Latin Spanish'), ($i18n.locale = 'Latin Spanish')]
                      "
                      class="dropdown-item"
                      >Latin Spanish</a
                    >
                  </li>
                  <li>
                    <a
                      href="#"
                      @click="[changeLocale('Mongolian'), ($i18n.locale = 'Mongolian')]"
                      class="dropdown-item"
                      >Mongolian</a
                    >
                  </li>
                  <li>
                    <a
                      href="#"
                      @click="[changeLocale('Russian'), ($i18n.locale = 'Russian')]"
                      class="dropdown-item"
                      >Russian</a
                    >
                  </li>
                  <li>
                    <a
                      href="#"
                      @click="[changeLocale('Thai'), ($i18n.locale = 'Thai')]"
                      class="dropdown-item"
                      >Thai</a
                    >
                  </li>
                  <li>
                    <a
                      href="#"
                      @click="[changeLocale('Turkish'), ($i18n.locale = 'Turkish')]"
                      class="dropdown-item"
                      >Turkish</a
                    >
                  </li>
                  <li>
                    <a
                      href="#"
                      @click="[changeLocale('Ukrainian'), ($i18n.locale = 'Ukrainian')]"
                      class="dropdown-item"
                      >Ukrainian</a
                    >
                  </li>
                </ul>
              </div>
            </div>
            <div class="h_search_box">
              <a href="#" class="h_search_bt" @click="clickSearch">search</a>
              <div class="mobile_s_inner">
                <div class="ms_box">
                  <div class="ms_inner container">
                    <p class="mmobile_s_int">
                      <input
                        type="text"
                        class="m_int"
                        v-model="searchWord"
                        placeholder="Suffix or Model"
                        title="search"
                        autocomplete="off" 
                        @keydown.down="onKeyEventActive"
                        @keydown.up="onKeyEventActive"
                        @input="getSuggestList"
                        @keyup.enter="goSearchPageOrSetSearchword"
                      />
                      <ul v-if="this.suggestShow" @mouseleave="suggestShow=false" class="autocomplete-ul">
                          <li class="autocomplete-li" :class="{ 'is-active': i === arrowCounter }" @mouseover="onMouseEventActive(i)" @click="selectSuggest(term)" v-for="(term,i) in suggestList" v-bind:key="i">{{term}}</li>
                      </ul>
                    </p>
                    <div class="m_s_bt_box">
                      <router-link
                        to="/search"
                        class="modal_search_bt"
                        @click.native="goSearchPageOrSetSearchword"
                        >{{ $t("common.search") }}</router-link
                      >
                      <input
                        type="button"
                        class="sub_search_close"
                        @click="closeSearch"
                        value="close"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--오른쪽 모바일 메뉴 버튼-->
          <div class="mobile_nav_box">
            <a href="#" class="mobile_nav_bt" @click="mobileNavClick">{{
              $t("common.mobileMenu")
            }}</a>
          </div>
          <!--메인 메뉴-->
          <div class="header_nav">
            <nav class="nav-class">
              <ul>
                <li
                  v-for="(menu, index) in this.$session.get('parentMenu')"
                  :key="index"
                  @mouseover="onOver(menu.menuId)"
                >
                  <!--메인 헤더-->
                  <router-link
                    :to="menu.menuUrl"
                    :class="{ on: $store.state.active == menu.label }"
                    @mouseleave.native="mouseLeave"
                    @mouseover.native="mouseOver"
                    @click.native="classActive(menu.label)"
                    class="nav_menu"
                    >{{ menu.label }}</router-link
                  >
                  <!--헤더하단서브메뉴-->
                  <div
                    v-for="(menu, index) in parentMenu"
                    :key="index"
                    v-show="onMenuId == menu.menuId"
                    class="nav_submenu"
                  >
                    <ul @mouseleave="onLeave()" @mouseover="mouseOver">
                      <li
                        v-for="(cMenu, index) in childMenu"
                        v-show="cMenu.parentMenuId == onMenuId"
                        :key="index"
                      >
                        <router-link
                          :to="cMenu.menuUrl"
                          @click.native="
                            [
                              onLeave(),
                              classActive(menu.label),
                              saveComponentName(cMenu.label),
                            ]
                          "
                          >{{ cMenu.label }}</router-link
                        >
                      </li>
                    </ul>
                  </div>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
      <section>
        <!-- 모바일 메뉴	 -->
        <div class="modal_box" style="display: none; opacity: 0; right: -1000px"></div>
        <aside id="sidenav" class="left_sidebar" style="right: -446px; opacity: 0">
          <div class="mobile_top_box">
            <a href="javascript:void(0);" class="rn_close_bt" @click="rnCloseClick">{{
              $t("common.close")
            }}</a>
          </div>
          <div class="left_nav_wrap">
            <h2>메뉴</h2>
            <nav class="left_nav">
              <div
                v-if="this.$session.get('parentMenu') == null"
                id="accordion_mobile"
                class="ui-accordion ui-widget ui-helper-reset"
                role="tablist"
              >
                <span v-for="(menu, index) in parentMenu" :key="index">
                  <h3
                    @click="onOverMobile(menu.menuId)"
                    :class="{ on: onMenuId == menu.menuId }"
                    class="ui-accordion-header ui-state-default ui-corner-all ui-accordion-icons pointer_cursor"
                    role="tab"
                    id="ui-id-1"
                    aria-controls="ui-id-2"
                    aria-selected="false"
                    aria-expanded="false"
                    tabindex="0"
                  >
                    <span
                      class="ui-accordion-header-icon ui-icon ui-icon-triangle-1-e"
                    ></span
                    >{{ menu.label }}
                  </h3>
                  <div
                    v-show="onMenuId == menu.menuId"
                    class="left_sub_menu ui-accordion-content ui-helper-reset ui-widget-content ui-corner-bottom"
                    id="ui-id-2"
                    aria-labelledby="ui-id-1"
                    role="tabpanel"
                    aria-hidden="true"
                    style="display: none"
                  >
                    <ul>
                      <li v-for="(cMenu, index) in childMenu" :key="index">
                        <router-link
                          :to="cMenu.menuUrl"
                          @click.native="
                            [classActive(menu.label), saveComponentAndClose(cMenu.label)]
                          "
                          v-if="cMenu.parentMenuId == onMenuId"
                          >{{ cMenu.label }}</router-link
                        >
                      </li>
                    </ul>
                  </div>
                </span>
              </div>
              <div
                v-else
                id="accordion_mobile"
                class="ui-accordion ui-widget ui-helper-reset"
                role="tablist"
              >
                <span
                  v-for="(menu, index) in this.$session.get('parentMenu')"
                  :key="index"
                >
                  <h3
                    @click="onOverMobile(menu.menuId)"
                    :class="{ on: onMenuId == menu.menuId }"
                    class="ui-accordion-header ui-state-default ui-corner-all ui-accordion-icons pointer_cursor"
                    role="tab"
                    id="ui-id-1"
                    aria-controls="ui-id-2"
                    aria-selected="false"
                    aria-expanded="false"
                    tabindex="0"
                  >
                    <span
                      class="ui-accordion-header-icon ui-icon ui-icon-triangle-1-e"
                    ></span
                    >{{ menu.label }}
                  </h3>
                  <div
                    v-show="onMenuId == menu.menuId"
                    class="left_sub_menu ui-accordion-content ui-helper-reset ui-widget-content ui-corner-bottom"
                    id="ui-id-2"
                    aria-labelledby="ui-id-1"
                    role="tabpanel"
                    aria-hidden="true"
                    style="display: none"
                  >
                    <ul>
                      <li v-for="(cMenu, index) in $session.get('subMenu')" :key="index">
                        <router-link
                          :to="cMenu.menuUrl"
                          @click.native="
                            [classActive(menu.label), saveComponentAndClose(cMenu.label)]
                          "
                          v-if="cMenu.parentMenuId == onMenuId"
                          >{{ cMenu.label }}</router-link
                        >
                      </li>
                    </ul>
                  </div>
                </span>
              </div>
              <div v-if="this.$session.get('loginUser') != null" class="left_nav_login">
                <a href="#" @click="goLogout" class="mobile-dropdown-item-logoutbtn">{{
                  $t("common.logout")
                }}</a>
              </div>
              <div v-else class="left_nav_login nav_login">
                <router-link to="/login" @click.native="rnCloseClick">{{
                  $t("common.login")
                }}</router-link>
              </div>
            </nav>
          

            <div class="m_n_bottom">
              <div class="m_n_sns">
                <ul>
                  <li>
                    <a
                      href="https://www.facebook.com/hd-hyundai-infracore"
                      target="_blank"
                      >{{ $t("common.facebook") }}</a
                    >
                  </li>
                  <li>
                    <a
                      href="https://www.instagram.com/hd.hyundai_infracore/"
                      class="instagram_icon"
                      target="_blank"
                      >{{ $t("common.instagram") }}</a
                    >
                  </li>
                  <li>
                    <a
                      href="https://www.linkedin.com/company/hd-hyundai-infracore"
                      class="linkedin_icon"
                      target="_blank"
                      >{{ $t("common.linkedIn") }}</a
                    >
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </aside>
      </section>
    </header>
  </div>
</template>

<script>
import carousel from "vue-owl-carousel";
import $ from "jquery";
import { getMenuList } from "@/api/menu";
import { logout } from "@/api/login";
import { getSearchSuggestList } from "@/api/search";

export default {
  data() {
    return {
      active: "",
      parentMenu: this.$session.get("parentMenu"),
      childMenu: this.$session.get("subMenu"),
      onMenuId: "",
      showToggle: false,
      loginId: this.$session.get("loginUser"),
      originUrl: "",
      logoutYN: false,
      searchWord: "",
      firstLogin: false,
      // 나중에 로케일 이름 Store 또는 Session 에서 가져오기
      localeName: "English",
      router: window.location.pathname,
      user: "",
      date: new Date().toISOString(),
      suggestList : [],
      suggestShow : false,
      arrowCounter: 0 ,
    };
  },
  components: { carousel },
  methods: {
    // menu 불러오기
    async getMenu() {
      try {
        const { data } = await getMenuList();
        this.$session.set("parentMenu", data.parentMenu);
        this.$session.set("subMenu", data.childMenu);
        this.childMenu = this.$session.get("subMenu");
        this.parentMenu = this.$session.get("parentMenu");
        this.user = data.user;
        if (this.$session.get("loginUser") == null) {
          if (this.user != null) {
            this.$session.set("user", this.user);
            this.$session.set("userName", this.user.userName);
            this.$session.set("loginUser", this.user);
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    classActive(data) {
      if (this.$session.get("loginUser") != null || data == "Support") {
        this.$store.commit("setComponentName", "");

        this.active = data;
        this.$store.commit("setActive", data);
      } else {
        this.active = "";
        this.$store.commit("setActive", "");
      }
    },
    onOver(menuId) {
      if (
        this.$session.get("parentMenu") != null &&
        this.$session.get("loginUser") != null
      ) {
        if (this.firstLogin == false) {
          this.parentMenu = this.$session.get("parentMenu");
          this.childMenu = this.$session.get("subMenu");
          this.firstLogin = true;
        }
      }
      this.onMenuId = menuId;
    },
    onOverMobile(menuId) {
      if (
        this.$session.get("parentMenu") != null &&
        this.$session.get("loginUser") != null
      ) {
        if (this.firstLogin == false) {
          this.parentMenu = this.$session.get("parentMenu");
          this.childMenu = this.$session.get("subMenu");
          this.firstLogin = true;
        }
      }
      if (this.onMenuId == menuId) {
        this.onMenuId = "";
      } else {
        this.onMenuId = menuId;
      }
    },
    onLeave() {
      this.onMenuId = "";
      this.mouseLeave();
    },
    saveComponentName(menuLabel) {
      this.$store.commit("setPage", 1);
      this.$store.commit("setSearchWord", "");
      this.$store.commit("setComponentName", menuLabel);
      this.componentName = menuLabel;
    },
    saveComponentAndClose(componentName) {
      this.$store.commit("setPage", 1);
      this.$store.commit("setSearchWord", "");
      this.$store.commit("setComponentName", componentName);
      this.componentName = componentName;
      this.rnCloseClick();
    },
    goMyLibrary() {
      this.$router.push({ name: "bookmarksList" });
    },
    //언어 변경
    changeLocale(language) {
      this.localeName = language;
    },
    confirmLogout() {
      this.logoutYN = confirm(this.$t("common.confirmLogout"));
      if (this.logoutYN == true) {
        this.goLogout();
      } else {
        return;
      }
    },
    async goLogout() {
      try {
        await logout();
        this.$store.commit("setLoginUser", "");
        this.$session.destroy();
        this.loginId = null;
        this.firstLogin = false;
        this.userName = "";
        this.active = "";
        this.$store.commit("setActive", "");
        this.getMenu();
        this.$router.push("/login");
      } catch (error) {
        console.log(error);
      }
    },
    reset() {
      this.active = "";
      this.$store.commit("setActive", "");
    },
    //검색페이지
    goSearchPageOrSetSearchword() {
      // autocomplete 체크 및 검색
      let active = $(".is-active");
      if(active){
        let text = $(active).text();
        if(text){
          // 검색어 선택
          this.selectSuggest(text);
        }else{
          this.closeSearch();
          this.classActive("");
          this.$router.push({ name: "pdf", query : {searchWord : this.searchWord },params: { searchWord: this.searchWord } });
        }
      }else{
        this.closeSearch();
        this.classActive("");
        this.$router.push({ name: "pdf", query : {searchWord : this.searchWord },params: { searchWord: this.searchWord } });
      }
    },
    // 검색어 autocomplete 이벤트1
    async getSuggestList(){
      try {
          const resp = await getSearchSuggestList(this.searchWord);
          if(resp!=null && resp.data.suggestList.length>0){
            this.suggestShow = true;
            this.suggestList = resp.data.suggestList;
            this.arrowCounter=-1;
          }else{
            this.suggestShow = false;
          }
      } catch (err) {
          console.log(err);
      }
    },
    // 검색어 autocomplete 이벤트2 (키보드 동작)
    onKeyEventActive(e){
      if (this.suggestList.length > 0) {
        if(e.code=="ArrowDown"){
          ++this.arrowCounter;
        }else{
          --this.arrowCounter;
        }
        if (this.arrowCounter >= this.suggestList.length)
          // this.arrowCounter = 0;
          this.arrowCounter = (this.arrowCounter) % this.suggestList.length;
        else if (this.arrowCounter < 0)
          this.arrowCounter = this.suggestList.length + this.arrowCounter;
          // this.arrowCounter = this.suggestList.length;
      }
    },
    // 검색어 autocomplete 이벤트3 (마우스 동작)
    onMouseEventActive(index){
      $(".autocomplete-li").removeClass("is-active");
      this.arrowCounter = index;
    },
    // 검색어 autocomplete 이벤트4 (자동완성 선택)
    selectSuggest(term){
      this.searchWord=term;
      this.suggestShow=false;
    },
    // jQuery side Menu
    mobileNavClick() {
      $(".left_sidebar").animate({
        right: "0px",
        opacity: "1",
      });
      $(".modal_box").animate({
        opacity: "0.7",
        right: "0",
      });
      $(".h_search_box").animate({
        opacity: "1",
        top: "12px",
      });
      $(".modal_box").attr("style", "display:block;");
      $("html").addClass("not_scroll");
    },
    rnCloseClick() {
      $(".modal_box").animate({
        opacity: "0",
        right: "-1000px",
      });
      $(".h_search_box").animate({
        opacity: "0",
        top: "-50",
      });
      $(".modal_box").attr("style", "display:none;");
      $(".left_sidebar").animate({
        right: "-446px",
        opacity: "0",
      });
      $("html").removeClass("not_scroll");
    },
    accordionMobile() {
      $("#accordion_mobile").accordion({
        heightStyle: "content",
        active: "",
      });
    },
    //	 검색
    clickSearch() {
      $(".mobile_s_inner").addClass("search_active");
      $("html, body").addClass("not_scroll");
    },
    closeSearch() {
      $(".mobile_s_inner").removeClass("search_active");
      $("html, body").removeClass("not_scroll");
    },
    mouseOver() {
      $(".main_header").addClass("m_header_bg");
    },
    mouseLeave() {
      $(".main_header").removeClass("m_header_bg");
    },
    // 메인 header 스크롤 배경
    handleScroll() {
      var scroll = $(window).scrollTop();
      if (scroll >= 50) {
        $(".main_header").addClass("m_header_bg");
      } else {
        $(".main_header").removeClass("m_header_bg");
      }
      // });
    },
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
    if (this.$session.get("parentMenu") == null && this.$session.get("subMenu") == null) {
      this.getMenu();
    }
  },
};
</script>

<style scoped>
.dropdown-menu {
  background: #2f2f2ff0 !important;
}

.dropdown-menu a {
  color: #fff !important;
}

.dropdown-item-mygsis {
  display: block;
  padding: 0 0 0 50px;
  line-height: 30px;
  background: url(../../img/background/drop_mygsis_icon.png) no-repeat 10% 50%;
  color: #fff;
}

.dropdown-item-logoutbtn {
  display: block;
  padding: 0 0 0 50px;
  line-height: 30px;
  background: url(../../img/background/drop_logout_icon.png) no-repeat 10% 50%;
  color: #fff;
}
.mobile-dropdown-item-logoutbtn {
  display: block;
  padding: 0 0 0 27px;
  line-height: 30px;
  background: url(../../img/background/drop_logout_icon.png) no-repeat 0 50%;
  color: #fff;
}

.dropdown-item:hover {
  color: #2f2f2ff0;
  background-color: #666;
}

.dropdown-item-mygsis:hover {
  color: #2f2f2ff0;
  background-color: #666;
}

.dropdown-item-logoutbtn:hover {
  color: #2f2f2ff0;
  background-color: #666;
}
.autocomplete-ul{
    width: 510px;
    background: white;
    margin-top: 22px;
    position: absolute;
    z-index: 1000;
    /* height: 200px;
    overflow: auto; */
}
.autocomplete-li{
    padding: 10px;
}

/* .autocomplete-li:hover{
    background: #f2faff;
} */

.is-active {
  background-color: #f2faff;
}
</style>
